import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import { FormattedMessage } from "react-intl";

import Modal from 'react-modal'

import './EmailConfirmationModal.scss'

const Tick = () => (
  <div style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    }}
  >
    <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.8 2.03636L10.7636 0L4.94545 5.81818L2.03636 2.90909L0 4.94545L4.94545 9.89091L12.8 2.03636Z" fill="#90C42C" />
    </svg>
  </div>
)

class EmailConfirmationModal extends Component {
  constructor (props) {
    super(props)
  }

  render() {
    const customStyles = {
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '2rem',
        width: '50rem',
        height: '48rem',
        overflow: "hidden",
      },
    }

    const { handleModalShown, isEmailConfirmed } = this.props

    return (
      <Modal
        isOpen={true}
        style={customStyles}
        className='email-confirmation-modal'
      >
        <div className="logo-wrapper">
          <img src="lib/images/logo.svg" alt="" />
        </div>
        {/* <div onClick={() => handleModalShown(false)} className="close-icon">
          <img src="assets/images/close.png" alt="" />
        </div> */}
        <div className='informative-section'>
          <p className='informative-text'>
            {isEmailConfirmed ? <FormattedMessage id="home.confirmation.confirmed" /> : <FormattedMessage id="home.confirmation.notConfirmed" />}
          </p>
          <p className='informative-subtext'>
            {isEmailConfirmed ? <FormattedMessage id="home.confirmation.confirmed.text" /> : <FormattedMessage id="home.confirmation.notConfirmed.text" />}
          </p>
        </div>
        <div className="buttons-section">
          <button type="submit" onClick={() => handleModalShown(false)} className="green-button"><FormattedMessage id="home.confirmation.button" /></button>
        </div>
      </Modal>
    )
  }
}

export default EmailConfirmationModal
